import React from 'react';
import './ReferenceDocs.css'; // Crearemos este archivo de CSS a continuación

interface ReferenceDocsProps {
  docs: Record<string, string>;
}

// Función auxiliar para limpiar el nombre del archivo
const formatFilename = (fullPath: string): string => {
  // Separa por la barra invertida (escapada) o la barra normal y toma el último elemento
  const parts = fullPath.split(/[\\/]/);
  return parts[parts.length - 1];
};

const ReferenceDocs: React.FC<ReferenceDocsProps> = ({ docs }) => {
  // Si no hay documentos o el objeto está vacío, no renderizamos nada
  if (!docs || Object.keys(docs).length === 0) {
    return null;
  }

  return (
    <div className="docs-container">
      <h4>Base de conocimiento</h4>
      <div className="docs-list">

        {Object.entries(docs).map(([filename, href]) => (
          
          <div key={filename} className="doc-chip">
              <span>
                📎 {formatFilename(href)}
              </span>
          </div>
        )
        )}
      </div>
    </div>
  );
};

export default ReferenceDocs;